import React from "react";
import "./luck.scss";
const Luck = () => {
  return (
    <>
      <section className="luckmain" id="luck">
        <div className="custom-container">
          <div className="luckinner">
            <div className="luckleft">
              <span className="luckspan">The LUCK Token</span>
              <h4 className="luckhead">LUCK — The Fuel Behind Fairness</h4>
              <ul>
                <li>Pay for randomness generation</li>
                <li>Stake to run RNG nodes (v2+)</li>
                <li>Earn rewards for validation</li>
                <li>Govern upgrades and parameters</li>
              </ul>
            </div>
            <img
              src="/assets/luckrightimg.png"
              alt="luckrightimg"
              className="luckrightimg"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Luck;
